import { render, staticRenderFns } from "./TaobaoDataTab.vue?vue&type=template&id=589b2eb0"
import script from "./TaobaoDataTab.vue?vue&type=script&lang=js"
export * from "./TaobaoDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports